import { createFileRoute } from '@tanstack/react-router'
import { SentinelOverviewPage } from 'pages/facilityModel/SentinelOverviewPage'
import { facilityModelSubjectSearchParams } from 'routes/facility-model/-searchParams'

const RouteComponent = () => {
  const { siteId } = Route.useSearch()
  return <SentinelOverviewPage siteId={siteId ?? null} />
}

export const Route = createFileRoute('/facility-model/sentinels/')({
  component: RouteComponent,
  validateSearch: facilityModelSubjectSearchParams,
  staticData: {
    title: 'Sentinels',
    layout: {
      enableScrolling: false,
    },
  },
})
